export const countryTranslations = {
  "Sweden": "Sverige",
  "USA": "USA",
  "Canada": "Kanada",
  "Panama": "Panama",
  "Afghanistan": "Afghanistan",
  "Albania": "Albanien",
  "Algeria": "Algeriet",
  "Andorra": "Andorra",
  "Angola": "Angola",
  "Argentina": "Argentina",
  "Armenia": "Armenien",
  "Australia": "Australien",
  "Austria": "Österrike",
  "Azerbaijan": "Azerbajdzjan",
  "Bahamas": "Bahamas",
  "Bahrain": "Bahrain",
  "Bangladesh": "Bangladesh",
  "Barbados": "Barbados",
  "Belarus": "Vitryssland",
  "Belgium": "Belgien",
  "Belize": "Belize",
  "Benin": "Benin",
  "Bhutan": "Bhutan",
  "Bolivia": "Bolivia",
  "Bosnia and Herzegovina": "Bosnien och Hercegovina",
  "Botswana": "Botswana",
  "Brazil": "Brasilien",
  "Brunei": "Brunei",
  "Bulgaria": "Bulgarien",
  "Burkina Faso": "Burkina Faso",
  "Burundi": "Burundi",
  "Cambodia": "Kambodja",
  "Cameroon": "Kamerun",
  "Cape Verde": "Kap Verde",
  "Central African Republic": "Centralafrikanska republiken",
  "Chad": "Tchad",
  "Chile": "Chile",
  "China": "Kina",
  "Colombia": "Colombia",
  "Comoros": "Komorerna",
  "Congo": "Kongo",
  "Costa Rica": "Costa Rica",
  "Croatia": "Kroatien",
  "Cuba": "Kuba",
  "Cyprus": "Cypern",
  "Czech Republic": "Tjeckien",
  "Denmark": "Danmark",
  "Djibouti": "Djibouti",
  "Dominica": "Dominica",
  "Dominican Republic": "Dominikanska republiken",
  "Ecuador": "Ecuador",
  "Egypt": "Egypten",
  "El Salvador": "El Salvador",
  "Equatorial Guinea": "Ekvatorialguinea",
  "Eritrea": "Eritrea",
  "Estonia": "Estland",
  "Ethiopia": "Etiopien",
  "Fiji": "Fiji",
  "Finland": "Finland",
  "France": "Frankrike",
  "Gabon": "Gabon",
  "Gambia": "Gambia",
  "Georgia": "Georgien",
  "Germany": "Tyskland",
  "Ghana": "Ghana",
  "Greece": "Grekland",
  "Grenada": "Grenada",
  "Guatemala": "Guatemala",
  "Guinea": "Guinea",
  "Guinea-Bissau": "Guinea-Bissau",
  "Guyana": "Guyana",
  "Haiti": "Haiti",
  "Honduras": "Honduras",
  "Hungary": "Ungern",
  "Iceland": "Island",
  "India": "Indien",
  "Indonesia": "Indonesien",
  "Iran": "Iran",
  "Iraq": "Irak",
  "Ireland": "Irland",
  "Israel": "Israel",
  "Italy": "Italien",
  "Jamaica": "Jamaica",
  "Japan": "Japan",
  "Jordan": "Jordanien",
  "Kazakhstan": "Kazakstan",
  "Kenya": "Kenya",
  "Kiribati": "Kiribati",
  "Kuwait": "Kuwait",
  "Kyrgyzstan": "Kirgizistan",
  "Laos": "Laos",
  "Latvia": "Lettland",
  "Lebanon": "Libanon",
  "Lesotho": "Lesotho",
  "Liberia": "Liberia",
  "Libya": "Libyen",
  "Liechtenstein": "Liechtenstein",
  "Lithuania": "Litauen",
  "Luxembourg": "Luxemburg",
  "Madagascar": "Madagaskar",
  "Malawi": "Malawi",
  "Malaysia": "Malaysia",
  "Maldives": "Maldiverna",
  "Mali": "Mali",
  "Malta": "Malta",
  "Marshall Islands": "Marshallöarna",
  "Mauritania": "Mauretanien",
  "Mauritius": "Mauritius",
  "Mexico": "Mexiko",
  "Micronesia": "Mikronesien",
  "Moldova": "Moldavien",
  "Monaco": "Monaco",
  "Mongolia": "Mongoliet",
  "Montenegro": "Montenegro",
  "Morocco": "Marocko",
  "Mozambique": "Moçambique",
  "Myanmar": "Myanmar",
  "Namibia": "Namibia",
  "Nauru": "Nauru",
  "Nepal": "Nepal",
  "Netherlands": "Nederländerna",
  "New Zealand": "Nya Zeeland",
  "Nicaragua": "Nicaragua",
  "Niger": "Niger",
  "Nigeria": "Nigeria",
  "North Korea": "Nordkorea",
  "Norway": "Norge",
  "Oman": "Oman",
  "Pakistan": "Pakistan",
  "Palau": "Palau",
  "Palestine": "Palestina",
  "Papua New Guinea": "Papua Nya Guinea",
  "Paraguay": "Paraguay",
  "Peru": "Peru",
  "Philippines": "Filippinerna",
  "Poland": "Polen",
  "Portugal": "Portugal",
  "Qatar": "Qatar",
  "Romania": "Rumänien",
  "Russia": "Ryssland",
  "Rwanda": "Rwanda",
  "Saint Kitts and Nevis": "Saint Kitts och Nevis",
  "Saint Lucia": "Saint Lucia",
  "Saint Vincent and the Grenadines": "Saint Vincent och Grenadinerna",
  "Samoa": "Samoa",
  "San Marino": "San Marino",
  "Sao Tome and Principe": "São Tomé och Príncipe",
  "Saudi Arabia": "Saudiarabien",
  "Senegal": "Senegal",
  "Serbia": "Serbien",
  "Seychelles": "Seychellerna",
  "Sierra Leone": "Sierra Leone",
  "Singapore": "Singapore",
  "Slovakia": "Slovakien",
  "Slovenia": "Slovenien",
  "Solomon Islands": "Salomonöarna",
  "Somalia": "Somalia",
  "South Africa": "Sydafrika",
  "South Korea": "Sydkorea",
  "South Sudan": "Sydsudan",
  "Spain": "Spanien",
  "Sri Lanka": "Sri Lanka",
  "Sudan": "Sudan",
  "Suriname": "Surinam",
  "Swaziland": "Swaziland",
  "Switzerland": "Schweiz",
  "Syria": "Syrien",
  "Taiwan": "Taiwan",
  "Tajikistan": "Tadzjikistan",
  "Tanzania": "Tanzania",
  "Thailand": "Thailand",
  "Timor-Leste": "Östtimor",
  "Togo": "Togo",
  "Tonga": "Tonga",
  "Trinidad and Tobago": "Trinidad och Tobago",
  "Tunisia": "Tunisien",
  "Turkey": "Turkiet",
  "Turkmenistan": "Turkmenistan",
  "Tuvalu": "Tuvalu",
  "Uganda": "Uganda",
  "Ukraine": "Ukraina",
  "United Arab Emirates": "Förenade Arabemiraten",
  "United Kingdom": "Storbritannien",
  "Uruguay": "Uruguay",
  "Uzbekistan": "Uzbekistan",
  "Vanuatu": "Vanuatu",
  "Vatican City": "Vatikanstaten",
  "Venezuela": "Venezuela",
  "Vietnam": "Vietnam",
  "Yemen": "Jemen",
  "Zambia": "Zambia",
  "Zimbabwe": "Zimbabwe"
};